import { axiosInstance } from "@/config/axios";
import { CommonRequestProps } from "@/requests";
import { StornoType, StornoTypeUrl } from "@/types/contract";

export const stornoContract = async ({
  contractUuid,
  stornoType,
}: {
  stornoType: StornoTypeUrl;
} & CommonRequestProps) => {
  return await axiosInstance.post(`/contract/${contractUuid}/storno/`, {
    storno_type: stornoType === StornoTypeUrl.StornoAdmin ? StornoType.ADMIN : StornoType.CUSTOMER,
  });
};
